//Note: the BaseTheme navigator, out for the first time.
//If you fix things here, edit the git repo too, or at tell Patrick.
const PRODUCTS_PER_AJAX = 50;
function rs_navigator(collection_name, PRODUCTS_PER_PAGE, PRODUCT_RENDERER, CUSTOM_FILTERS, CUSTOM_FILTERS_STRINGS) {

  // GLOBAL VARIABLES:
  var allProducts = {},     // all products in the collection/page
      sortParam = '';
  //rather than constantly querying these, set it and forget it
  var gparams = {
    page: 1,
    q: undefined,//might override these off the url
    filterOptions: undefined,
    sortby: undefined
  };

//random functions
function splitParams(url) {
  if (!url) url = window.location.href;
  var a = decodeURIComponent(url.substring(1)).split('&'),
    out = [];

  for (var i = 0; i < a.length; i++) {
    var _  = a[i].split('=');
    out[_[0]] = _[1];
  }
  return out;
}

function pushState() {
  var params = { }, needsparams = false;
  if (gparams != 1) {
    params.pg = gparams.page;
    needsparams= 1;
  }
  if (gparams.q) {
    params.q = gparams.q;
    needsparams = 1;
  }
  var url = undefined;
  if (needsparams) {
    url = "?" + $.param(params);
  };
  history.pushState(
    {
      filterOptions: gparams.filterOptions
    },
    ' ',//title, ignored
    url
  );
}


//PAGINATION DIV

  function pagination_init() {
    $("#pagination").on('click', 'a',function (e) {
      e.preventDefault();
      var page = $(this).attr('title')
      if (page === '') {
        page = '999';
      }
      if (page !== '999') {
        page = parseInt(page);
        if (page != gparams.page) {
          gparams.page = page;
          pushState();
        }
      }
      paginateProducts(page);
      if (page === '999') {
      //  $("html, body").animate({ scrollTop: $('#product-loop > .grid__item:nth-child(' + ((history.state.page - 1) * PRODUCTS_PER_PAGE + 1) + ')').offset().top }, 500);
//The history page only has number value as long as the all/999 setting does not ever get saved.
      } else {
        $("html, body").animate({ scrollTop: 0 }, 500);//might also go to product-loop
      }
    });
  }
  function setPaginator(currPage) {
    if (1 >= totalPages) {
      $('#pagination').html('');
      return;
    }
    var paginator = "";
    if (currPage !== '999') {
      paginator +=
      ((currPage - 1 >= 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">Prev</a>' : '')
      + ((currPage !== 1) ? '<a href="/collections/' + collection_name + '?page=1" title="1">1</a>' : '' )
      + ((currPage >= 4) ? '…' : '')
      + ((currPage - 2 > 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 2) + '" title="' + (currPage - 2) + '">' + (currPage - 2) + '</a>' : '' )
      + ((currPage - 1 > 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">' + (currPage - 1) + '</a>' : '' )
      + '<span class="current">' + currPage + '</span>'
      + ((currPage + 1 < totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">' + (currPage + 1) + '</a>' : '' )
      + ((currPage + 2 < totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 2) + '" title="' + (currPage + 2) + '">' + (currPage + 2) + '</a>' : '' )
      + ((currPage <= totalPages - 4) ? '…' : '')
      + ((currPage !== totalPages) ? '<a href="/collections/' + collection_name + '?page=' + totalPages + '" title="' + totalPages + '">' + totalPages + '</a>' : '' )
      + ((currPage + 1 <= totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">Next</a>' : '');
    }
    paginator += '<a href="/collections/' + collection_name + '?page=' + (currPage === '999' ? "1" : '999' ) + '" title="' + (currPage === '999' ? "1" : '' ) + '">View ' + (currPage === '999' ? "less" : 'all' ) + '</a>';
    $('#pagination').html(paginator).show();
  }

  function getPage(page) {
    gparams.page = page;
    pushState();
    paginateProducts(page);
  }



// FILTERING

 function unsetFilterOption(ukey, uval) {
   if (gparams.filterOptions == undefined) return;
   $('.rs-and').each(function(k, andblock) {
    var key = $(this).data('tag') || $(this).find('ul').data('title');
    if (key != ukey) return;
    $(andblock).find('.rs-or').each(function(k, v) {
      if(gparams.filterOptions.indexOf($(this).data('tag') || $(this).text()) >= 0) {
        var val = $(this).data('tag') || $(this).text().toLowerCase().replace(',', '').replace(',', '');
        if (val != uval) return;
        $(this).removeClass('filter-selected')
        $(this).siblings('label').find('i').toggle();
        return false;
      }
    });
    if ($(andblock).find('.rs-range').length > 0) {
      var explode = gparams.filterOptions[0].split('-');//TEST? I don't remember how this works
      //see note about more than one range per block
      if (explode[0].length > 0) $(andblock).find('.rs-or-min').val('');
      if (explode[1].length > 0) $(andblock).find('.rs-or-max').val('');
    }
   });
   return false;
 }

function setFilterOptions(options) {
  if (gparams.filterOptions == undefined) return;
  // filter options:
  $('.rs-and').each(function(k, andblock) {
    var key = $(this).data('tag') || $(this).find('ul').data('title');
    var andOptions = options.filterOptions[key];
    if (andOptions && andOptions.length) {
      $(andblock).find('.rs-or').each(function(k, v) {
        if(andOptions.indexOf($(this).data('tag') || $(this).text()) >= 0) {
          $(this).addClass('filter-selected')
        }
      });
      if ($(andblock).find('.rs-range').length > 0) {
        var explode = andOptions[0].split('-');
        //this assumes there's only 1 range in the block. Nobody else does.
        //Should match the options array with -range array
        if (explode[0].length > 0) $(andblock).find('.rs-or-min').val(explode[0]);
        if (explode[1].length > 0) $(andblock).find('.rs-or-max').val(explode[1]);
      }
    }
  })
  // sort by:
  if(options.sortBy) {
    $('select#SortBy').val(options.sortBy);
  }
  filtershown(options.filterOptions);
}

  /** helper function for pFilter */
  function basicSearch(ortags, classes) {
   var or = false;
   $.each(typeof ortags == 'object' ? ortags : [ortags], function (i, tag) {
     if (classes.indexOf(tag) > -1) {
       or = true;
       return false;
     }
   });
   return or;
 };
 /** helper function for pFilter*/
 function basicTagSearch(ortags, object) {
   return basicSearch(ortags, object.tags);
 }
 function pFilter(filters, object){
  var and = true;
  $.each(filters, function (i, ortags) {
    if(ortags && ortags.length) {
      and = and && (CUSTOM_FILTERS[i]||basicTagSearch)(ortags, object);
    }
  });
  return and;
}







// HISTORY STATE

// toggle side filters:
 $('#rs-filtermenu').find('.fa-plus-circle').css('display','inline-block');
 $('#rs-filtermenu').find('.fa-minus-circle').css('display','none');
 $('#rs-filtermenu .filter-item').css('display','none');
 $('#rs-filtermenu .clearall').css('display','none');

 $('#rs-filtermenu').on('click', '.accordion-side-menu-sub > label', function() {
   $(this).siblings('li').slideToggle();
   $(this).find('i').toggle();
   $(this).siblings('.clearall').toggle();
 })

 $('#rs-filtermenu').on('click', '.filter-item', function() {
   $(this).toggleClass('filter-selected');
   document.dispatchEvent(new CustomEvent('rs-filter.change'))
 })
 // reset filters:
 $('#rs-filtermenu').on('click', '.clearall', function() {
   $(this).siblings('.filter-selected').removeClass('filter-selected');
   document.dispatchEvent(new CustomEvent('rs-filter.change'))
 })
 $('#rs-filtermenu').on('click', '.clear-filter-item', function(){
   unsetFilterItem($(this).data('block'),$(this).data('tag'))
   document.dispatchEvent(new CustomEvent('rs-filter.change'))
 });
 $('#rs-filtermenu').on('click', '.rs-change-filter', function(){
   document.dispatchEvent(new CustomEvent('rs-filter.change'))
 });
 $('#rs-clearall').on('click', function(){
   $('.filter-selected').removeClass('filter-selected');
   $('.rs-range input').val('');
   document.dispatchEvent(new CustomEvent('rs-filter.change'))
 });

var filterProducts = function(data) {
  var output  = [],
      filters = gparams.filterOptions;
  if (filters && Object.keys(filters).length) {
    for (var i = 0; i < data.length; i++) {
      if (pFilter(filters, data[i])) {
        output.push(data[i]);
      }
    }
  } else {
    output = data
  }
  //EVENTUALLY: use gparams.q to further reduce output.
  //Would need to be nearly as useful as the built-in search, but would allow for better cached data.
  //Might also be able to: search by price ranges, variants without tags (does shopify do that?)
  return output;
}



//PRODUCTS

function product_init() {
  $('#product-loop').on('click', '.grid__item a', function() {
    //save the div id as the scroll state, instead of the pixels
    history.state.scrollTo = $(this).closest('.grid__item').attr('id');
    history.replaceState(history.state, '');//TEST: that the div works the same as the scrollTop()
  });
  $('select#SortBy').on('change', function(){
    gparams.sortBy = $(this).val();
    paginateProducts(gparams.page);
  });
}
function product_sort(products) {
  var sortf=false;
  if (gparams.sortBy == 'title-descending')
    sortf = function (b,a) { return a.title.localeCompare(b.title)}
  else if (gparams.sortBy == 'title-ascending')
    sortf = function (a,b) { return a.title.localeCompare(b.title)}
  else if (gparams.sortBy == 'price-ascending')
    sortf = function (a,b) { return a.price - b.price}
  else if (gparams.sortBy == 'price-descending')
    sortf = function (b,a) { return a.price - b.price}
  else if (gparams.sortBy == 'created-ascending')
    sortf = function (a,b) { return a.created_at > b.created_at}
  else if (gparams.sortBy == 'created-descending')
    sortf = function (b,a) { return a.created_at > b.created_at}
  if (sortf) products.sort(sortf)
}
function paginateProducts (page) {
  products = filterProducts(allProducts);
  product_sort(products)
  totalPages = Math.ceil(products.length / PRODUCTS_PER_PAGE);
  $("#num-products").html("("+products.length+") items");

  if (products.length > 0 && page) {

    if (page !== '999' && page > totalPages) {
      page = 1;
    }
    var endNdx = ( (products.length < (page * PRODUCTS_PER_PAGE)) || (page === '999') ) ? products.length : page * PRODUCTS_PER_PAGE;//is either all available products, or a single page
    var productGrid = "";
    var startIdx = (page === '999' || (endNdx < PRODUCTS_PER_PAGE)) ? 0 : (page - 1) * PRODUCTS_PER_PAGE;//is either 0, or the start of the page
    for (var i=startIdx; i < endNdx; i++ ) {
      productGrid += PRODUCT_RENDERER.renderProduct(i, products[i]);
    }
    // render HTML
    $('#rs-notfound').hide();
    $("#product-loop").html(productGrid).removeClass('no-results').show();
    setPaginator(page);
  } else {
    $('#rs-notfound').show();
    $('#pagination').hide();
    $("#product-loop").hide();
  }
  document.dispatchEvent(new CustomEvent('rs-navigator.paginator'))
}


document.addEventListener('rs-filter.change', function() {
  gparams.filterOptions = fillFilter();
  filtershown(gparams.filterOptions);
  gparams.page = 1;
  //replace state for each filter change?
  //also, the original version did not reset the page number
  paginateProducts(gparams.page);
});

function filtershown(filterOptions) {
 //generate another list of shows filters
 if ($('#filtershown').length === 0) {
   return
 }
  $('#filtershown').html('');
  var defaultString = function(ortag) {
    return ortag;
  }
   $.each(filterOptions, function (key, ortags) {
     var _ = CUSTOM_FILTERS_STRINGS[key] || defaultString;
     $.each(ortags, function(i,ortag) {

       $('#filtershown').append('<li class="clear-filter-item" data-block="'+key+'" data-tag="'+
                                ortag+'"><a>'+
 _(ortag)+'</a><span class="ion-close-round"></span></li>');
     });
   });
}

function fillFilter(){
  var andtags = {};
  $('#rs-filtermenu').find('.rs-and').each(function (i, andblock){
    var ora = [];
    $(andblock).find('.rs-or.filter-selected').each(function(i, orb) {
      ora.push($(this).data('tag') || $(this).text().toLowerCase().trim().replace('& ', ' and ').replace(',', ''));
    })
    $(andblock).find('.rs-range').each(function(i, orb) {
      var min = $(orb).find('.rs-or-min').val();
      var max = $(orb).find('.rs-or-max').val();
      if (min != '' || max != '') {
      ora.push(min+'-'+max);
      }
    })
    if (ora.length) andtags[$(andblock).data('tag') || $(andblock).find('ul').data('title')] = ora;
  });
  return andtags;
}







function pageInit() {
  setFilterOptions(gparams);
  paginateProducts(gparams.page);

  if (history.state && history.state.scrollTo) {
    var $scroll = $('#'+history.state.scrollTo);
    if ($scroll.length == 1) {
      //$('#product-loop').imagesLoaded().done( function( instance ) {
        $('html, body').animate({ scrollTop: $scroll.offset().top }, 700);
      //});
    }
  }
}



function finishAjax() {
  if(collection_name === "search") {
    $('body').addClass('template-collection');
  }
  pagination_init();
  product_init();
  pageInit();

  $("#num-products").html("("+allProducts.length+") items");

  $('#ajaxLoader').hide();
  $('#spinner').addClass('done');
}

function loadDataAsset(url) {
  $.get(url,function(data) {
      allProducts = JSON.parse(data);
      finishAjax();
  })
}

function loadDataJSON(productsCount, search_terms) {
  productsCount = parseInt(productsCount);
  var pagesCount = Math.ceil(productsCount / PRODUCTS_PER_AJAX),
  search = '',
  //PROGRAMMER: pick one of these
  //view = "view=metafields&page=";//includes metadata
  view = "view=json&page=";//slightly simpler

  if (search_terms) {
    search = 'q='+ escape(search_terms) + '&type=product&'
    //note: far less likely to be cached. Ideally, do the search internally.
  }//TEST:search url
  var baseUrl = location.pathname + '?' + search + view;

    // allProducts = new Array(productsCount);
    allProducts = productsCount ? new Array(productsCount) : [];
    totalPages = Math.ceil(productsCount / PRODUCTS_PER_PAGE);

  //INIT VIA AJAX:
  var requests = [];

  for (var i = 1; i<= pagesCount; i++) {
    let page = i;
    requests.push(
      $.get(baseUrl + page + sortParam, function(data) {
        var items = JSON.parse(data);
        for (var j = 0; j < items.length; j++) {
          allProducts[((page - 1) * PRODUCTS_PER_AJAX) + j] = items[j];
        }
      })
    );
  }

  $.when.apply($, requests).done(function() {
    allProducts = allProducts.filter(function(v, i) {
      return v ? v : null;
    });
    finishAjax();
  });
}


window.addEventListener('popstate', function(e) {
  //popstate does not trigger on initial page load
  if(e.state) {
    console.log(e);
    gparams = e.state;
    pageInit();
  }
});



//init has available to it only the variables passed in, and the page url
// should not actually do anything

function navinit() {
  var ps = splitParams();
  if (ps.q) {
    gparams.q = ps.q
  }
  if (ps.pg) {
    gparams.page = ps.pg
  }
  //get the tags off the url? Will be in the setFilter/popstate, but would be nice for a reload
}



navinit();
  return {
'loadDirectly':function(products, current_page) {
  allProducts = products;
  gparams.page = current_page

  //render 1 page, assuming liquid did all filtering.
  //don't worry about setting the selected filters here.
  //Do not override the anchors, let it go back to Shopify
  //TODO: set the pagition anchors to grab the JSON out of the page render.
  // reset allProducts, the page number, then re-render. Faster than re-loading the entire page.
}
,
'loadRemotely':function(src, asset_url, total_products, search_count, search_terms) {
  $('#ajaxLoader').show();
  $('#spinner').removeClass('done');
  //start the load the data from the url(s)
  //Init the anchor overrides
  if (src === 'json') {
    loadDataJSON(total_products||search_count, search_terms)
  } else {
    loadDataAsset(asset_url)
  }
}
,
'setFiltering':function(tags, search){
  //TODO: set the css on the filters There's a function for that
  gparams.filterOptions = tags;
  //FO is an array (and-level) of arrays (or-level) of items. Tags is an array of strings, but it is smart enough to figure that out.
  gparams.q = search;

  setFilterOptions(gparams);

  filtershown(gparams.filterOptions);
  //if we have any data, render it immediately.
  if (allProducts.length) {
    pageInit();
  }
  //else ajaxFinish will get to it eventually
}
,
'setView': function (all) {
  if (all) {
    gparams.page = '999';
  } else {
    gparams.page = 1;
  }
  paginateProducts(gparams.page);
}
  }
}
